import posthog from "posthog-js";
import { TRACKING_EVENTS } from "./posthog";

export const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY ?? "";
export const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "";
export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID ?? "";
export const GOOGLE_ADS_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID ?? "";
const GADS_LABEL_LEAD = process.env.NEXT_PUBLIC_GOOGLE_ADS_LABEL_LEAD ?? "";

export const initMetaPixel = () => {
  if (!META_PIXEL_ID || typeof window === "undefined") return;
  if ((window as any).fbq) return;
  // @ts-ignore
  !function(f,b,e,v,n,t,s)
  // @ts-ignore
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  // @ts-ignore
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  // @ts-ignore
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  // @ts-ignore
  n.queue=[];t=b.createElement(e);t.async=!0;
  // @ts-ignore
  t.src=v;s=b.getElementsByTagName(e)[0];
  // @ts-ignore
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  // @ts-ignore
  window.fbq("init", META_PIXEL_ID);
  // @ts-ignore
  window.fbq("track", "PageView");
};

export const initGoogleAds = () => {
  if (!GOOGLE_ADS_ID || typeof window === "undefined") return;
  if ((window as any).__gadsLoaded) return;
  (window as any).__gadsLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
  document.head.appendChild(s);
  (window as any).dataLayer = (window as any).dataLayer || [];
  function gtag(...args: any[]) {
    (window as any).dataLayer.push(args);
  }
  (window as any).gtag = gtag;
  gtag("js", new Date());
  gtag("config", GOOGLE_ADS_ID);
};

export const initPixels = () => {
  initMetaPixel();
  initGoogleAds();
};

// Conversions envoyées à Meta + Google Ads (PostHog reçoit tout).
const CONVERSION_MAP: Record<string, { metaEvent?: string; gadsLabel?: string }> = {
  [TRACKING_EVENTS.LEAD_QUALIFIED]: { metaEvent: "Lead", gadsLabel: GADS_LABEL_LEAD },
};

export const identifyLead = (email: string, properties?: Record<string, any>) => {
  if (posthog) posthog.identify(email, properties);
};

export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  if (posthog) posthog.capture(eventName, properties);
  if (typeof window === "undefined") return;

  const conversion = CONVERSION_MAP[eventName];
  if (!conversion) return;
  if (conversion.metaEvent && (window as any).fbq) {
    (window as any).fbq("track", conversion.metaEvent, properties);
  }
  if (conversion.gadsLabel && (window as any).gtag) {
    (window as any).gtag("event", "conversion", {
      send_to: conversion.gadsLabel,
      ...properties,
    });
  }
};
